
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.94 8.94L7.878 10 10 12.121l1.06-1.06-2.12-2.122zm10.12-5.88A1.5 1.5 0 0016.94.94l2.12 2.12zm-8 8l8-8L16.94.94l-8 8 2.12 2.12z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.94 11.06L10 12.122 12.121 10l-1.06-1.06-2.122 2.12zM3.06.94A1.5 1.5 0 00.94 3.06L3.06.94zm8 8l-8-8L.94 3.06l8 8 2.12-2.12z","fill":"#fff"}})])
          )
        }
      }
    